<script lang="ts">
	import type { Lesson } from '$lib/types/hygraph';
	import { classes, styles } from '$lib/utils';
	import { createEventDispatcher } from 'svelte';
	import { browser } from "$app/environment";

	const dispatch = createEventDispatcher();

	export let lesson: Lesson | undefined;
	export let href: string;
	export let prefix: string;

	export let active = false;
	export let last = false;
	export let additionalClass = '';
	export let additionalStyle = '';
</script>

<div class={classes('', additionalClass)} style={styles('', additionalStyle)}>
	<a {href}>
		<div
			on:click={() => dispatch('select', { lesson })}
			on:keydown={() => dispatch('select', { lesson })}
			class="flex items-center border-b border-b-black px-4 py-6 hover:bg-gray-100 cursor-pointer {active
				? 'text-black'
				: 'text-gray-400'}"
			data-elb="lesson" data-elbaction="click:viewed " data-elb-course="lesson_name:{lesson?.name};lesson_slug:{browser ? window.location.pathname : ''}"
		>
			<div
				class="rounded-full border{last ? ' border-b-none' : ''} w-8 h-8 mr-4 flex items-center justify-center {active
					? 'text-purple border-purple'
					: 'text-gray-400 border-gray-400'}"
				style="flex: 0 0 auto;"
			>
				{prefix}
			</div>
			<div>
				{lesson?.name}
			</div>
		</div>
	</a>
</div>
